//const apiStaging = 'http://staging-api.pharmedistore.docker.aliases/'
const apiDev = process.env.URL_CSCART ?? 'http://back-cscart-pharmedistore.localhost:1070'
const apiStaging = 'https://staging-api.pharmedistore.com/'
const backOfficeStaging = 'https://staging-api.pharmedistore.com/'

const SETTINGS = {
  dev: {
    vendorUrl: `${process.env.URL_CSCART}/vendor.php`,
    apiUrlCscart: `${apiDev}/api/5.0/pharme_`,
    urlExtranetGroup: process.env.URL_GROUP_FRONT,
    facebookId: '427931781236630',
    googleId: 'G-7VHR9XZW10',
    googleTagManager: 'GTM-M9JVWH6',
    hjsv: 6,
    hjid: 1931218,
    hjidAeliaStore: 1931218,
    apiKeyCsCart: process.env.API_KEY_CSCART,
    apiTokenAdminCsCart: process.env.API_TOKEN_ADMIN_CSCART,
    channel: 'chatbot-pharmedistore',
    clientKey: '6LcYxswUAAAAAI1ColJEnq1-ku1PbZsapDTpzg6n',
    wisePopsKey: 'ZHdtUJY7DH',
    google: {
      client_id: '974772593309-73vf5nkqslk7qg0afmr6jg59kgj8te9t.apps.googleusercontent.com',
    },
  },
  staging: {
    vendorUrl: `${backOfficeStaging}vendor.php`,
    apiUrlCscart: `${apiStaging}api/5.0/pharme_`,
    urlExtranetGroup: 'https://extranet-staging.pharmedigroup.com/',
    facebookId: '427931781236630',
    googleId: 'G-7VHR9XZW10',
    googleTagManager: 'GTM-M9JVWH6',
    hjsv: 6,
    hjid: 1931218,
    hjidAeliaStore: 1931218,
    apiKeyCsCart: process.env.API_KEY_CSCART,
    apiTokenAdminCsCart: process.env.API_TOKEN_ADMIN_CSCART,
    clientKey: '6LcYxswUAAAAAI1ColJEnq1-ku1PbZsapDTpzg6n',
    google: {
      client_id: '974772593309-73vf5nkqslk7qg0afmr6jg59kgj8te9t.apps.googleusercontent.com',
    },
  },
  production: {
    vendorUrl: 'https://extranet.pharmedistore.com/vendor.php',
    apiUrlCscart: 'https://api.pharmedistore.com/api/5.0/pharme_',
    urlExtranetGroup: 'https://extranet.pharmedigroup.com/',
    facebookId: '2287905434810253',
    googleId: 'G-2MF9BVMYQ8',
    googleTagManager: 'GTM-M9JVWH6',
    hjsv: 6,
    hjid: 2031579,
    hjidAeliaStore: 6538384,
    apiKeyCsCart: process.env.API_KEY_CSCART,
    apiTokenAdminCsCart: process.env.API_TOKEN_ADMIN_CSCART,
    clientKey: '6LdYguYUAAAAAM_mk_q6l4UHHtgHpiNeD1wmEsWo',
    google: {
      client_id: '974772593309-73vf5nkqslk7qg0afmr6jg59kgj8te9t.apps.googleusercontent.com',
    },
  },
  crisp: {
    CRISP_WEBSITE_ID: '628f101d-bb09-407e-b686-2ebc615a09f7',
  },
  localeDefault: 'fr',
  logdna: {
    apiKey: '2bc20a1360edcadbc7088144f79c3dbf',
  },
  modePaiement: {
    idPaiementSepa: 2, //old 7
    idPaiementCb: 1, // old 6
    idPaiementAmexDeferred: 3,
    idPaiementTypeSepa: 'sepa_debit',
    idPaiementTypeCard: 'card',
  },
  intlAdmin: { name: 'Admin', lang_code: 'zu' },
  feature: { devis: false },
  seo: {
    title: 'Pharmedistore',
    description:
      'Pharmaciens, achetez sur internet les dernières innovations en parapharmacie : objets connectés santé, produits cosmétiques bio, naturels ou vegan, solaire bio, maternité grossesse et bébé, phytothérapie, compléments alimentaires... de quoi diversifier vos linéaires et vous différencier.\n' +
      '\n' +
      '1ère marketplace B to B dédiée aux officines, alternative innovante aux distributeurs, grossistes et centrales d’achat pour vos approvisionnements, nous proposons des produits exclusifs à des tarifs attractifs avec des quantités minimales réduites ainsi que des franco de port. Identifiez les grandes tendances en parapharmacie grace aux avis pharmaciens. A l’image d’AMAZON, découvrez chaque semaine de nouveaux produits et laboratoires internationaux pour développer votre pharmacie. Ils nous font confiance : LANSINOH, LEA NATURE, I HEALTH, TEANE, BIVOUAK, DODOW, WEENECT, Laboratoires de BIARRITZ, KARETHIC, SISSEL, BURT’S BEES, EGYPTIAN MAGIC, DOUX ME, IBBEO COSMETIQUES, BLUE TENSE,  HAPSATOU SY, SAISONS D’EDEN, MIMITIKA, STAR BALM, NUBY... et beaucoup d’autres.',
  },
  FRAIS_PREPARATION_DECLINATION_ID: '9291',
  FRAIS_PREPARATION_CAP_DECLINATION_ID: '9289',
  FRAIS_PREPARATION_PHARMEDICAP_DECLINATION_ID: '17472',
  FRAIS_PREPARATION_NORCAP_DECLINATION_ID: '20393',
  PRODUCT_ID_SUBSCRIPTION_FREMUIM: '50889',
  USERGROUPID_OFFICINAL: '25',
  // Groupe utilisateur Zydus : forfait d'abonnement transforme en credit mensuel.
  USERGROUPID_ZYDUS: '68',
  PHARMAGEST: {
    orderTimeout: 1000,
    customerName: 'pharmagest',
  },
  attributesCodeUse: {
    brand: 'brand',
    brandId: '5',
    marketingPublicPrice: 'marketing_public_price',
    coeffMarge: 'marketing_coeff_marge',
    marketingPublicPriceId: '116',
    idCoeffQuantity: '119',
    coeffMargeId: '116',
    attributesDateShipping: '122',
    compagnyIdLapPlus: '568',
    compagnyIdLap: '1057',
    compagnyIdNorcap: '741',
    compagnyIdPharmedistore: '228',
  },
  categoryBrandLeader: 1052,
  categoryAntiGaspi: '1801',
  idFiltersFacet: {
    recommandationId: '4',
    categoryId: '3',
    vendorId: '11',
    brandId: '1',
    filterPriceId: '2',
    discountId: '10',
    bioId: '6',
    ecoResponsableId: '5',
    destockageId: '13',
  },
  contact: {
    mail: 'contact@pharmedistore.com',
    phone_pharmedistore: '+331 47 95 51 89',
    fb_link: 'https://www.facebook.com/pharmedistore/',
    insta_link_officinales: 'https://www.instagram.com/officap.fr',
    mail_officinales: 'contact@officap.fr',
    mail_aeliastore: 'contact@aeliastore.fr',
    mail_cos: 'contact@lacentralecos.com',
    mail_centraleMediprix: 'contact@lacentralemediprix.fr',
    mail_pharmacologyStore: 'contact@pharmacologystore.fr',
    mail_centraleDpharma: 'contact@lacentraledpharma.fr',
    mail_officap: 'contact@officap.fr',
    mail_helloPharmacie: 'contact@lacentralehellopharmacie.fr',
    mail_normandiePharma: 'contact@lacentralenormandiepharma.fr',
    mail_37degres: 'contact@37degres-macentrale.fr',
    phone_officinales: '01 47 95 51 89',
    fb_link_officinales: 'https://www.facebook.com/officap.fr',
    insta_link: 'https://www.instagram.com/pharmedistore',
  },
  storefrontDefault: 1,
  storefrontAelia: 6,
  storefrontCos: 7,
  storefrontLesOfficinales: 8,
  storefrontGcapPharma: 9,
  storefrontCentraleMediprix: 11,
  storefrontPharmacologyStore: 12,
  storefrontCentraleDpharma: 13,
  storefrontOutreMer: 10,
  storefrontHelloPharmacie: 14,
  storefrontNormandiePharma: 15,
  storefront37Degres: 16,
  fraisPlateforme: '9,99',
  ORDER: {
    STATUS: {
      TRAITE: 'C',
      EN_ATTENTE: 'P',
      TERMINEE: 'H',
    },
  },
  RMA: {
    REASONS: {
      0: 'Produits manquants',
      1: 'Produits abîmés',
      2: 'Produits non conformes',
      // Litige d'entete, sans produit : le motif est porte par le litige lui-meme.
      3: 'Demande de facture',
    },
    STATUS: {
      C: 'Complété',
      R: 'Demandé',
      A: 'Accepté',
    },
  },
}

export default SETTINGS
